import React from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { App } from './App';
import { NotFound } from './components/NotFound';
import { RedirectIfNoPartnerDriverToken } from './components/RedirectIfNoPartnerDriverToken';
import { Signup } from './components/Signup';
import { SignupFormLayout } from './components/SignupFormLayout';
import { AppPromotion } from './components/app_promotion/AppPromotion';
import { DriverSignupMinimalLayout } from './components/driver_form/DriverSignupMinimalLayout';
import { FinalScreen } from './components/final_screen/FinalScreen';
import { RiderUserSignup } from './components/rider_user_signup/RiderUserSignup';
import { PickOtpChannel } from './components/verification/PickOtpChannel';
import { VerificationWrapper } from './components/verification/VerificationWrapper';
import { setRouter } from './common/navigation';

export const router = createBrowserRouter(
  [
    {
      path: '/driver',
      element: <App />,
      children: [
        { path: 'verification/:token', element: <VerificationWrapper /> },
        { path: 'pickOtpChannel/:token', element: <PickOtpChannel /> },
        { path: 'appPromotion', element: <AppPromotion /> },
        { path: '404', element: <NotFound /> },
        { path: 'authRequired', element: <RedirectIfNoPartnerDriverToken /> },
        { path: 'riderUserSignup', element: <RiderUserSignup /> },
        { path: 'form', element: <DriverSignupMinimalLayout /> },
        {
          element: <SignupFormLayout />,
          children: [
            { index: true, element: <Signup /> },
            { path: 'final', element: <FinalScreen /> },
            { path: '*', element: <Signup /> },
          ],
        },
      ],
    },
    { path: '*', element: <Navigate to="/driver/404" replace /> },
  ],
  {
    future: {
      v7_relativeSplatPath: true,
      v7_fetcherPersist: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_skipActionErrorRevalidation: true,
    },
  }
);

setRouter(router);
